/* eslint-disable import/prefer-default-export */
import { useAppTheme } from "../../../app/providers/ThemeProvider";
import { getMapUi } from "../constants";

export function useMapUi() {
  const { isDarkMode } = useAppTheme();
  return getMapUi(isDarkMode);
}
